import { cfAxios } from '@/utils/init-axios.js'
import endpoints from '@/utils/endpoints.js'
import {
  maskCardNumbers,
  CardComplianceViolation
} from '@/utils/card-compliance'

export type BlockedSendComposer = 'chat' | 'group'

export interface BlockedSendReport {
  /** Merchant org pkid; the gateway routes are keyed by pkid, not UUID. */
  merchantId: number | string | null | undefined
  violation: CardComplianceViolation
  /** The refused draft, as typed. Card numbers are masked here before it leaves the browser. */
  message: string
  composer: BlockedSendComposer
  customerId?: string | null
  accountId?: string | null
}

/**
 * Tell messaging-service about a Send the composer refused. It posts a Slack alert naming the
 * collector so the account team can follow up. Fire and forget: the composer has already blocked the
 * send, so a failed report is logged and otherwise ignored.
 */
export async function reportBlockedSend({
  merchantId,
  violation,
  message,
  composer,
  customerId = null,
  accountId = null
}: BlockedSendReport): Promise<void> {
  if (merchantId === undefined || merchantId === null || merchantId === '') {
    return
  }
  try {
    await cfAxios.post(endpoints.blockedMessageAttempts(merchantId), {
      violation,
      message: maskCardNumbers(message),
      composer,
      customerId,
      accountId
    })
  } catch (error) {
    console.warn('blocked send report failed', error)
  }
}
